// Angular imports
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

// 3rd party imports
import { DxPopupComponent } from 'devextreme-angular';

// CC-Common imports
import {
  CCTimeZoneService,
  UtcToUserTimezonePipe,
  TimezoneConstants,
  IconConstants
} from '@therealmanage/ciranet-ui-common';
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

//Service imports
import { EnvironmentConfigService } from '../../_services/environment-config.service';
import { HelperService } from '../../_services/shared-services/helper.service';
import { PrecisionService } from '../../_services/shared-services/precision.service';
import { UserBackgroundService } from '../../_services/shared-services/user-background.service';

//Constant imports
import { StorageKeyConstants } from '../../_constants/storage-key-constants';
import { ThemeColor, ThemeColors } from '../../_constants/theme-colors';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
  providers: [UtcToUserTimezonePipe],
  standalone: false
})
export class PreferencesComponent implements OnInit {
  @ViewChild('preferencesPopup', { static: false })
  preferencesPopup: DxPopupComponent;
  @Output() preferrencePopClose = new EventEmitter<boolean>();

  preferencesVisible = false;
  themeColors: ThemeColor[];
  timeZones: string[];
  selectedThemeColor: string;
  selectedTimeZoneName: string;
  selectedPrecision: number;
  timezoneConstant: any[];

  cancelButtonIcon = IconConstants.CANCEL;
  saveButtonIcon = IconConstants.SAVE;

  constructor(
    private helperService: HelperService,
    private userBackgroundService: UserBackgroundService,
    private precisionService: PrecisionService,
    private ccTimezoneService: CCTimeZoneService,
    private envConfig: EnvironmentConfigService
  ) {
    this.themeColors = ThemeColors;
    this.timezoneConstant = TimezoneConstants.abbreviations;
    this.timezoneConstant.forEach((r) => {
      r.displayText = `${r.text.split(' ')[0]} ${r.value}`;
    });
  }

  ngOnInit() {
    this.loadPreferencesEditor();
  }

  show() {
    this.preferencesVisible = true;
    this.loadPreferencesEditor();
  }

  hide() {
    this.preferencesVisible = false;
    if (this.preferrencePopClose != null) {
      this.preferrencePopClose.emit(false);
    }
  }

  repaint(): void {
    this.preferencesPopup.instance.repaint();
  }

  loadPreferencesEditor() {
    // Theme
    this.selectedThemeColor = localStorage.getItem(
      StorageKeyConstants.userThemeKey
    );

    if (!this.selectedThemeColor) {
      localStorage.setItem(
        StorageKeyConstants.userThemeKey,
        this.envConfig.defaultThemeColor
      );
      this.selectedThemeColor = this.envConfig.defaultThemeColor;
    }

    // Timezone
    const currentTimeZone = this.helperService.getUserTimezone();
    if (currentTimeZone) {
      this.selectedTimeZoneName =
        this.getSelectableTimezoneName(currentTimeZone);
    } else {
      RxjsUtils.safeSubscribe(
        this.ccTimezoneService.getLocalTimezone(),
        (data) => {
          this.selectedTimeZoneName = this.getSelectableTimezoneName(data);
        }
      );
    }

    this.timeZones = this.timezoneConstant.map((r) => r.displayText);
    /*
        this.ccTimezoneService.getTimezones().subscribe((data) => {
            this.timeZones = data;
        });
        */
    // Rounding
    const precision = this.precisionService.getPrecision();
    if (
      !!precision &&
      Number.isInteger(precision) &&
      precision >= 0 &&
      precision <= 4
    ) {
      this.selectedPrecision = precision;
    } else {
      this.selectedPrecision = this.envConfig.defaultRounding;
    }
  }

  onApplyClick() {
    // Theme
    localStorage.setItem(
      StorageKeyConstants.userThemeKey,
      this.selectedThemeColor
    );
    // time zone
    if (this.selectedTimeZoneName) {
      const timezoneToStore = this.getStorableTimezoneName(
        this.selectedTimeZoneName
      );
      localStorage.setItem(
        StorageKeyConstants.userTimeZoneKey,
        timezoneToStore.toString()
      );
    }
    // Rounding
    if (this.selectedPrecision != null) {
      localStorage.setItem(
        StorageKeyConstants.userPrecisionKey,
        this.selectedPrecision.toString()
      );
    }
    // Hide poppup
    this.preferencesVisible = false;
    this.userBackgroundService.logActivity(
      `save_preferences`,
      'SavePreferences',
      new Date(),
      'success'
    );
  }

  onCancelClick() {
    this.hide();
  }

  getSelectableTimezoneName(storedValue: string): string {
    const rec = this.timezoneConstant.find((r) => {
      return r.utc.indexOf(storedValue) !== -1;
    });
    return !!rec ? rec.displayText : storedValue;
  }

  getStorableTimezoneName(selectedValue: string): string {
    const rec = this.timezoneConstant.find((r) => {
      return r.displayText === selectedValue;
    });
    return !!rec ? rec.utc[0] : selectedValue;
  }
}
